export function getFile(file: string) {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', file + '?rand=' + Math.random(), false);
        xhr.onerror = reject;
        xhr.onreadystatechange = () => {
            if (xhr.readyState === 4) {
                if (xhr.status === 200 || xhr.status === 0) {
                    resolve(xhr.responseText);
                }else if(xhr.status > 400){
                    reject('Something went wrong! Status: ' + xhr.status);
                }
            }
        };
        xhr.send();
    });
}
